import React from 'react'
import Breadcrumb from '../1'
import { RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  titlePage: string
  noveltyId?: string
  developmentId?: string
  propertyId?: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps
const BreadCrumbs_4 = (props: CombinedProps) => {
  return (
    <div className="breadcrumb c breadcrumb d m-0">
      <div className="navbar-sticky">
        <Breadcrumb
          {...props}
          titleInTop={true}
        />
      </div>
    </div>
  )
}

export default BreadCrumbs_4
